module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/search-6d152a3ff9510984e172a842352ec8d2.svg";